import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'staff'
const initialState = {
  count: null,
  list: [],
  query: { limit: 10, offset: 0 },
  schoologyData: null,
  loading: false,
  recordLoading: false,
}

export const search = createApiAction('scheduling/course-session/search', client.search('/api/scheduling/course-session'))
export const get = createApiAction('scheduling/course-session/get', client.retrieve(`/api/scheduling/course-session/:id`))
export const save = createApiAction('scheduling/course-session/save', client.save('/api/scheduling/course-session'))
export const destroy = createApiAction('scheduling/course-session/delete', client.destroy('/api/scheduling/course-session/:id'))
export const getSchoologyData = createApiAction('scheduling/course-session/schoology', client.retrieve('/api/scheduling/schoology/files'))

const updateAcademicYearList = (state, action) => {
  const found = state.list.find(rec => rec.id === action.payload.id)
  state.list = found
    ? state.list.map(person => (found.id === person.id ? action.payload : person))
    : [...state.list, action.payload]
}

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    destroyCourseSessionEnrollment: (state, action) => {
      const id = action.payload
      const list = state.list
      list.forEach((cs, index) => {
        cs.courseSessionEnrollments.forEach((cse, ind) => {
          if (id && id === cse?.id) {
            delete list[index].courseSessionEnrollments[ind]
          }
        })
      })
      state.list = list
    },
    saveCourseSessionEnrollment: (state, action) => {
      const courseSessionId = +action.payload.courseSessionId
      const id = +action.payload.id
      state.list = state.list?.map(cs => {
        if (cs.id !== courseSessionId) return cs
        const exists = cs.courseSessionEnrollments?.some(cse => cse?.id === id)
        const enrollments = exists
          ? cs.courseSessionEnrollments.map(cse => (cse?.id === id ? action.payload : cse))
          : [...(cs.courseSessionEnrollments ?? []), action.payload]
        return { ...cs, courseSessionEnrollments: enrollments }
      })
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, state => {
        state.loading = true
      })
      .addCase(search.fulfilled, (state, action) => {
        if (!action.meta.arg?.export) {
          state.query = action.meta.arg
          state.count = action.payload.count
          state.list = action.payload.rows
          state.loading = false
        }
      })
      .addCase(getSchoologyData.fulfilled, (state, action) => {
        state.schoologyData = action.payload
      })
      .addCase(get.pending, state => {
        state.recordLoading = true
      })
      .addCase(get.fulfilled, (state, action) => {
        state.recordLoading = false
        updateAcademicYearList(state, action)
      })
      .addCase(save.fulfilled, updateAcademicYearList)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(ay => ay.id !== action.payload.id)
      })
  },
})

export const { destroyCourseSessionEnrollment, saveCourseSessionEnrollment } = sessionSlice.actions

export default sessionSlice.reducer
